export default {
  clear: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/layouts/clear.vue").then(m => m.default || m),
  default: () => import("/media/disk1/fordata/jenkins/rbdNodeJs/workspace/layouts/default.vue").then(m => m.default || m)
}